import Vue from 'vue'
import Router from 'vue-router'
import Index from "@/Index";
Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Pl',
            component: Index,
            meta: {
                lang: 'pl'
            }
        },{
            path: '/en',
            name: 'En',
            component: Index,
            meta: {
                lang: 'en'
            }
        }
    ]
});

export default router;
